var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"game-list-container",class:{'top': _vm.top, 'bottom': _vm.bottom}},[_c('article',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('article',{staticClass:"container-list"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }